import { cn } from "@/lib/utils"

export const STEP_DEFS = [
  { id: "pago",      label: "Pago",         full: "Pagamento Shopify",         src: "shop" },
  { id: "stock",     label: "Stock",        full: "Validação stock ETICDATA",  src: "etic" },
  { id: "eticdata",  label: "Enc. cliente", full: "Encomenda cliente ETICDATA", src: "etic" },
  { id: "forn",      label: "Fornecedor",   full: "Encomenda a fornecedor",    src: "sup"  },
  { id: "logistica", label: "Logística",    full: "PDF separação armazém",     src: "sys"  },
  { id: "fatura",    label: "Fatura",       full: "Fatura ETICDATA (FA-SW/FAT-W)", src: "etic" },
  { id: "expedicao", label: "Expedição",    full: "Expedição Correos Expresso",src: "ce"   },
] as const

export type StepId = typeof STEP_DEFS[number]["id"]
export type StepStatus = "done" | "current" | "waiting" | "error" | "pending"
export type StepStates = Partial<Record<StepId, StepStatus>>

const STATUS_LABEL: Record<StepStatus, string> = {
  done: "Concluído",
  current: "Em curso",
  waiting: "A aguardar acção",
  error: "Falha",
  pending: "Pendente",
}

export function StepDots({ states, currentStep }: { states: StepStates | null; currentStep?: string | null }) {
  const s = states ?? {}
  return (
    <span className="inline-flex items-center gap-1.5">
      {STEP_DEFS.map((step, idx) => {
        const status = s[step.id] ?? (currentStep === step.id ? "current" : "pending")
        const prevDone = idx > 0 && (s[STEP_DEFS[idx - 1].id] ?? "pending") === "done"
        return (
          <span key={step.id} className="flex items-center gap-1.5">
            {idx > 0 && (
              <span className={cn("h-0.5 w-2", prevDone ? "bg-emerald-500" : "bg-border")} />
            )}
            <Dot status={status} title={`${step.full} — ${STATUS_LABEL[status]}`} />
          </span>
        )
      })}
    </span>
  )
}

function Dot({ status, title }: { status: StepStatus; title?: string }) {
  return (
    <span
      title={title}
      className={cn(
        "block size-2.5 shrink-0 rounded-full transition-all",
        status === "done" && "bg-emerald-500",
        status === "current" && "bg-background ring-2 ring-inset ring-[var(--step-current)]",
        status === "waiting" && "bg-amber-50 ring-2 ring-inset ring-amber-500 animate-[pulse-waiting_1.6s_ease-in-out_infinite]",
        status === "error" && "bg-destructive",
        status === "pending" && "bg-[var(--step-pending)]",
      )}
    />
  )
}

export function getStepLabel(step: string | null | undefined): string {
  return STEP_DEFS.find((s) => s.id === step)?.label ?? "—"
}

export function getStepFullLabel(step: string | null | undefined): string {
  return STEP_DEFS.find((s) => s.id === step)?.full ?? "—"
}
